var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBloomCircle = function SvgBloomCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190,
    height: 169,
    viewBox: "0 0 190 169",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06279 67.3569C10.1742 52.2115 18.9258 38.5526 30.5491 27.5795C42.3679 16.2386 56.8827 8.09784 72.7225 3.92617C76.9892 2.82249 81.3343 2.04784 85.7196 1.60906C106.131 -0.663921 126.766 2.97498 145.169 12.0927C163.558 21.1397 177.744 36.9387 184.766 56.1929C189.45 69.2924 190.884 83.3331 188.945 97.1091C187.111 110.945 181.616 124.04 173.029 135.042C164.392 145.965 152.106 154.407 136.53 160.148C122.745 165.056 108.268 167.746 93.6396 168.117C89.9576 168.208 85.7655 168.216 81.0732 167.957C71.656 167.485 62.3226 165.947 53.2521 163.372C38.021 158.855 26.3191 151.683 18.2583 141.826C9.54811 131.295 3.82745 118.617 1.69457 105.118C-0.216401 92.4424 0.938546 79.4938 5.06279 67.3569Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBloomCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "BloomCircle.566803b8a8ccb8652bbb4ea8acfb1778.svg";